import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import root from 'window-or-global';
import {getURLParam} from '../../utils/Utils';

const Tab = ({title, onClick, isActive, ...props}) => {
    return (
        typeof title === 'string' ?
            <span className={isActive ? 'active' : ''} onClick={onClick}>{title}</span> :
            React.cloneElement(title, {...props})
    );
};

Tab.displayName = 'Tab';

Tab.propTypes = {
    title: PropTypes.string,
    onClick: PropTypes.func,
    isActive: PropTypes.bool
};

export default class Tabs extends React.PureComponent {
    static Tab = Tab;
    static defaultProps = {
        header: null,
        headerAvailable: null
    };

    state = {
        index: this.props.index
    };

    componentWillReceiveProps(nextProps) {
        const { index } = nextProps;
        if (!index) {
            return;
        }
        this.setState({index});
    }

    onTabChange = (index) => {
        const tab = getURLParam('tab');
        if (tab) {
            root.history.pushState({}, root.document.title, root.location.pathname);
        }
        this.setState({index});
    }

    PageTab = () => {
        const { children } = this.props;
        const count = React.Children.count(children);
        if (!count) {
            throw new Error('Content should not be empty');
        }
        const { index } = this.state;
        return (
            <div className="competitive-page-tab">
                { children.length ? children.map((child, idx) => {
                    if (!child) {
                        return null;
                    }
                    if (child && (child.type.name !== Tab.name)) {
                        console.error('Tab component should be included');
                    }
                    return (
                        <Tab isActive={index === idx} key={Math.random()} onClick={() => this.onTabChange(idx)} {...child.props} />
                    );
                }) : <Tab isActive={true} onClick={() => this.onTabChange(index)} {...children.props} />}
            </div>
        );
    };

    PagePanel = () => {
        let { index } = this.state;
        const { children } = this.props;
        const count = React.Children.count(children);
        index = (index > count) ? count : index;
        if (!count) {
            throw new Error('Content should not be empty');
        }
        const _currentContent = (count > 1) ? (children[index] && children[index].props.children) : children.props.children;
        return _currentContent ? React.cloneElement(_currentContent) : null;
    };

    render() {
        const {header, headerAvailable} = this.props;
        const {index} = this.state;
        const showHeader = headerAvailable.indexOf(index) > -1;
        return (
            <Fragment>
                <div className="tabs-top">
                    <this.PageTab key="tab.bar" />
                    {showHeader && header}
                </div>
                <this.PagePanel key="tab.panel" />
            </Fragment>
        );
    }
}

Tabs.propTypes = {
    children: PropTypes.node,
    header: PropTypes.node,
    headerAvailable: PropTypes.array,
    index: PropTypes.number
};
